import loadable from '@loadable/component'
import Loading from 'components/Loading/Loading'
import { timeout } from 'promise-timeout'
import React from 'react'
import { TIMEOUT_LOADER } from 'utils/globals'

const OrganizationECPFList = loadable(
  () => timeout(import(
    /* webpackChunkName: "OrganizationECPF" */
    'ecpf/app/OrganizationECPF/views/OrganizationECPFList/OrganizationECPFList'
  ), TIMEOUT_LOADER),
  {
    fallback: <Loading/>
  }
)

export { OrganizationECPFList }
